import { usePrefersReducedMotion } from '../../hooks/usePrefersReducedMotion';
import DigitalPixelBackdrop from './DigitalPixelBackdrop';
import '../AllCss/StarfieldBackground.css';

const LAYERED_VARIANTS = {
  mesh: ['mesh'],
  aurora: ['aurora'],
  orbs: ['orbs'],
  constellation: ['twinkle', 'glow'],
  grain: ['grain'],
  grid: ['grid'],
  dust: ['twinkle'],
  digital: ['digital'],
};

function StarfieldBackground({ variant = 'mesh', tone = 'light', className = '' }) {
  const reducedMotion = usePrefersReducedMotion();
  const layers = LAYERED_VARIANTS[variant] ?? LAYERED_VARIANTS.mesh;

  if (variant === 'digital') {
    return (
      <div
        className={[
          'hero-backdrop',
          'hero-backdrop--digital',
          `hero-backdrop--tone-${tone}`,
          reducedMotion ? 'hero-backdrop--reduced-motion' : '',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        aria-hidden="true"
      >
        <DigitalPixelBackdrop />
        <div className="hero-backdrop__digital-vignette" />
      </div>
    );
  }

  const rootClass = [
    'hero-backdrop',
    `hero-backdrop--${variant}`,
    `hero-backdrop--tone-${tone}`,
    reducedMotion ? 'hero-backdrop--reduced-motion' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass} aria-hidden="true">
      {layers.includes('mesh') && <div className="hero-backdrop__mesh" />}
      {layers.includes('aurora') && (
        <div className="hero-backdrop__aurora">
          <span className="hero-backdrop__blob hero-backdrop__blob--1" />
          <span className="hero-backdrop__blob hero-backdrop__blob--2" />
          <span className="hero-backdrop__blob hero-backdrop__blob--3" />
        </div>
      )}
      {layers.includes('orbs') && (
        <div className="hero-backdrop__orbs">
          <span className="hero-backdrop__orb hero-backdrop__orb--1" />
          <span className="hero-backdrop__orb hero-backdrop__orb--2" />
        </div>
      )}
      {layers.includes('twinkle') && <div className="hero-backdrop__twinkle" />}
      {layers.includes('glow') && <div className="hero-backdrop__glow" />}
      {layers.includes('grain') && <div className="hero-backdrop__grain" />}
      {layers.includes('grid') && <div className="hero-backdrop__grid" />}
    </div>
  );
}

export default StarfieldBackground;
